import { CheckCircle } from '@mui/icons-material';
import { Grid, Typography, Button, alpha, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MemberExportFormatEnum } from 'src/shared/models/enums/memberExportFormat.enum';
import { MemberExportTypeItem } from './memberAdvancedSearchExport';

type MemberAdvancedSearchExportFormatProps = {
  memberExportTypes: MemberExportTypeItem[];
  selectedFormat: MemberExportFormatEnum;
  callback: (val: MemberExportFormatEnum) => void;
};

export const MemberAdvancedSearchExportFormat = ({ memberExportTypes, selectedFormat, callback }: MemberAdvancedSearchExportFormatProps) => {
  const { t } = useTranslation(['member']);

  const handleButtonClick = (val: MemberExportFormatEnum) => callback(val);

  return (
    <Box
      sx={{
        p: {
          xs: 1,
          md: 3,
        },
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant='h6' sx={{ mb: 1 }}>
            {t('member:exportModal.selectExportFormatHeader')}
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mb: 2 }}>
          <Grid container spacing={2}>
            {memberExportTypes.map((exp) => (
              <Grid item xs={12} md={4} key={exp.key}>
                <Button
                  color='primary'
                  variant='outlined'
                  fullWidth
                  className={selectedFormat === exp.key ? 'selected' : ''}
                  sx={{
                    py: 3,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    height: '100%',
                    backgroundColor: '#fff',
                    position: 'relative',
                    '&:hover': {
                      backgroundColor: (theme) => alpha(theme.palette.success.light, 0.2),
                    },
                    '&.selected': {
                      borderWidth: 3,
                      backgroundColor: (theme) => alpha(theme.palette.success.light, 0.2),
                    },
                    '& .icon': {
                      width: '3rem',
                      height: '3rem',
                      opacity: 0.8,
                      mb: 2,
                    },
                  }}
                  onClick={() => handleButtonClick(exp.key as MemberExportFormatEnum)}
                >
                  {exp.icon}
                  <Typography variant='body1' component='div' sx={{ fontWeight: 100, display: 'flex', alignItems: 'center' }}>
                    {exp.label}
                    {selectedFormat === exp.key && (
                      <CheckCircle sx={{ width: '1.5rem', height: '1.5rem', opacity: 1, ml: 1, color: (thm) => thm.palette.success.main }} />
                    )}
                  </Typography>
                </Button>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
